import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import bannerImg from "assets/Images/bannerImg.jpg";
import { useLocation, useSearchParams } from "react-router-dom";
import { PATH } from "utils/pagePath";
import Input from "components/Input/Input";

const BannerBox = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === PATH.SUPPORT_PORTAL;
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState(searchParams.get("search") || "");

  useEffect(() => {
    const timer = setTimeout(() => {
      const params = new URLSearchParams(searchParams);
      if (searchValue) {
        params.set("search", searchValue);
      } else {
        params.delete("search");
      }
      setSearchParams(params);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchValue]);

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: 150, sm: 200 },
        backgroundColor: "#0B5FFF",
        backgroundImage: `url(${bannerImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "#fff",
        px: 3,
        borderRadius: 4,
      }}
    >

      {isLandingPage && (
        <>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "600",
              textAlign: "center",
              mb: isLandingPage ? 2 : 0,
              fontSize: { xs: "1.5rem", sm: "2rem" },
            }}
          >
            Welcome to the Help Center
          </Typography>
          <Box sx={{ width: "100%", maxWidth: "800px" }}>
            <Input
              placeholder="Search for information"
              searchable={true}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  height: "45px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default BannerBox;
